import { cn } from "@bem-react/classname";
import { getHref, getPortal, getProbNum, ITest, ITests, selectIsTestHover, selectTeacherJournal, setHoverTest, setMeanFrom, setMeanTo, setSort, toggleShowMark, toggleTest, updateTest } from "modules/TeacherJournal";
import { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../Journal.scss"
import { format } from "date-fns"
import { ru } from 'date-fns/locale'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import svgSortDowm from '../assets/sort_down.svg'
import svgSortUp from '../assets/sort_up.svg'


declare global {
    interface Window {
        test_properties(id: number, callback: Function, portal: string, subject: string):void
    }
}


const Test: FC<{test: ITest, noplist:boolean}> = ({test, noplist}) => {
    const jcn = cn('Journal')
    const dispatch = useDispatch()
    const state = useSelector(selectTeacherJournal)
    const hoverState = useSelector(selectIsTestHover(test.id))
    const tp_callback = ()=>dispatch(updateTest(test))
    const ref = useRef(null as (HTMLDivElement|null))
    useEffect(()=>{
        if (!noplist && hoverState){
            const r = ref.current as HTMLDivElement
            const t = r.parentElement as HTMLDivElement
            const pos = r.offsetLeft
            const curscroll = t?.scrollLeft?t?.scrollLeft:0
            const width = t?.clientWidth?t?.clientWidth:0
            const margLeft = (t?.firstChild as HTMLDivElement).offsetWidth
            const margRight = (t?.lastChild as HTMLDivElement).offsetWidth
            const elWidth = r.offsetWidth
            if (curscroll > pos - margLeft - 15){
                t.scrollTo({left: pos - margLeft - 15, behavior: "smooth"})
            } else if (curscroll < pos + elWidth + margRight - width + 5) {
                t.scrollTo({left: pos + elWidth + margRight - width + 5, behavior: "smooth"})
            }
        } else if (hoverState) {
            const r = ref.current as HTMLDivElement
            const t = r.parentElement as HTMLDivElement
            const pos = r.offsetTop
            const curscroll = t?.scrollTop?t?.scrollTop:0
            const height = t?.clientHeight?t?.clientHeight:0
            const margTop = 82
            const margBottom = 0
            const elHeight = r.offsetHeight
            if (curscroll > pos - margTop - 15){
                t.scrollTo({top: pos - margTop - 15, behavior: "smooth"})
            } else if (curscroll < pos + elHeight + margBottom - height + 5) {
                t.scrollTo({top: pos + elHeight + margBottom - height + 5, behavior: "smooth"})
            }
        }

    }, [hoverState, noplist])
    return <div ref={el => ref.current = el} className={jcn('Test') + (hoverState?(' ' + jcn('TestHover')):'')} title={'№ '+test.id} onClick={()=>dispatch(toggleTest(test.id))} onMouseEnter={()=>dispatch(setHoverTest(test.id))} onMouseLeave={()=>dispatch(setHoverTest(null))}>
        {test.isOpen&&!noplist?<>
        <div className={jcn('ProblineHeader')}>Тип задания</div>
        <div className={jcn('Probline')}>
        {test.problems.map((item, index) => <span className={jcn('Problineitem')} title={getProbNum(state, item)} key={index}>{item.type}</span>)}
        </div>
        <div className={jcn('Probline2')}>
        {test.problems.map((item, index) => <a target="_blank" rel="noreferrer" href={getHref(test, item)} className={jcn('Problineitem2')} key={index} title={item.id.toString()}>{index+1}</a>)}
        </div>
        </>:<>
        <div  className={jcn('TestInfo')}>
        {test.public === 1?"Контрольная ":"Домашняя "}
        № <a 
                onClick = {(e)=>{e.stopPropagation()}}
                target="_blank" 
                rel="noreferrer" 
                href={"https://"+getPortal(state)+"/test?id="+test.id}
            >{test.id}</a> 
        <img 
            src="/img/edit.png" 
            style={{width: '10px', cursor: 'pointer'}} 
            alt='Параметры варианта' 
            title='Параметры варианта' 
            onClick={(e)=>{e.stopPropagation(); window.test_properties(test.id, tp_callback, test.portal, test.subject)}}/>
        </div>
        <div className={jcn('TestTitle')}>{test.title}</div>
        <span className={jcn('FullDate')}>{format(test.sortdate?test.sortdate:test.time, "P", {locale: ru})}</span>
        <span className={jcn('ShortDate')}>{format(test.sortdate?test.sortdate:test.time, "dd.MM", {locale: ru})}</span>
        </>}
    </div>
}

export const HeaderRow: FC<{ tests: ITests, noplist?:boolean}> = ({tests, noplist}) => {
    const jcn = cn('Journal')
    const dispatch = useDispatch()
    const state = useSelector(selectTeacherJournal)
    const [sshow, setsshow] = useState(false)
    return <>
    <div className={jcn('Corner-NW')}>
        <span className={jcn('SortTitle')}>Сортировка по дате</span>
        <img src={svgSortDowm} alt={"Сначала старые"} title="Сначала старые" style={{color: state.options.sort === 'ASC'?'black':'grey'}} className={jcn('SortBtn')} onClick={()=>dispatch(setSort("ASC"))}/>
        <img src={svgSortUp} alt={"Сначала новые"} title="Сначала " style={{color: state.options.sort === 'DESC'?'black':'grey'}} className={jcn('SortBtn')} onClick={()=>dispatch(setSort("DESC"))}/>
        {/*<span title="сначала новые" style={{color: state.options.sort === 'DESC'?'black':'grey'}} className={jcn('SortBtn')} onClick={()=>dispatch(setSort("DESC"))}>←</span>
        <span title="сначала старые" style={{color: state.options.sort === 'ASC'?'black':'grey'}} className={jcn('SortBtn')} onClick={()=>dispatch(setSort("ASC"))}>→</span>*/}
        <span className={jcn('ShowMark')} onClick={()=>dispatch(toggleShowMark())}>{state.options.showMark === 3?'оценки / баллы':state.options.showMark === 1?'оценки':'баллы'}</span>
    </div>
    
    {tests.map((test, index)=><Test noplist={noplist?noplist:false} key={index} test={test} />)}
    {tests.length===0?<div className={jcn('Empty')}>Пока нет выполненных работ</div>:''}
    
        <div className={jcn('Corner-NE')}>
            {noplist?
                <div className={jcn('TestListTitle')}></div>
            :
                <><div className={'WrapSetDate'}><span style={{display: "block"}}>Среднее</span> <svg height="20" version="1.1" viewBox="0 0 24 24" width="20" onClick={()=>setsshow(!sshow)}>
                    <defs>
                    <path id="zub" d="m 10 0 l 0 1.2 l -3 0.5 l -0.5 1.5" stroke="black" strokeWidth="0.5"/>
                    </defs>
                    <circle cx="12" cy="12" r="4" stroke="black" strokeWidth="0.5" fill="none"/>
                    <use transform="translate(12,12) rotate(0)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12) rotate(45)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12) rotate(90)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12) rotate(135)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12) rotate(180)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12) rotate(225)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12) rotate(270)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12) rotate(315)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(0)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(45)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(90)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(135)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(180)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(225)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(270)"  xlinkHref="#zub"/>
                    <use transform="translate(12,12)  scale(1, -1) rotate(315)"  xlinkHref="#zub"/>
                </svg></div>
                {sshow?<div className={jcn("MeanDate")}>
                    среднее<br/>
                    <span style={{width:'15px', display:'inline-block'}}>c</span><div style={{display: 'inline-block', maxWidth: '100px'}}>
                        <DatePicker
                        selectsStart
                        onChange={(date)=>dispatch(setMeanFrom(date))}
                        selected={state.options.meanFrom}
                        placeholderText="любой даты"
                        dateFormat="dd.MM.yyyy"
                        startDate={state.options.meanFrom}
                        endDate={state.options.meanFrom}
                        locale={ru}
                    /></div><br/>
                    <span style={{width:'15px', display:'inline-block'}}>по</span><div style={{display: 'inline-block', maxWidth: '100px'}}>
                        <DatePicker 
                        selectsEnd
                        onChange={(date)=>dispatch(setMeanTo(date))}
                        selected={state.options.meanTo}
                        placeholderText="любую дату"
                        dateFormat="dd.MM.yyyy"
                        startDate={state.options.meanFrom}
                        endDate={state.options.meanFrom}
                        locale={ru}
                    /></div>
                </div>:''}
                </>}
    </div>
    </>
}